import {fingerprintSvg as Icon__small__fingerprintSvg} from '../Icon__small/Icon__small--fingerprint.js'

export var fingerprint = {
  name: 'fingerprint',
  category: 'icon',
  colorable: true,
  svg: Icon__small__fingerprintSvg,
};
